import { create } from 'zustand';
import type { User } from '@supabase/supabase-js';

// We map our role names
export type Role = 'superadmin' | 'admin' | 'rrhh' | 'supervisor' | 'facturador' | 'funcionario' | null;

interface AuthState {
    user: User | null;
    role: Role;
    isLoading: boolean;
    setUser: (user: User | null) => void;
    setRole: (role: Role) => void;
    setLoading: (loading: boolean) => void;
    /**
     * Limpia el estado local de sesión. **No cierra la sesión en Supabase**: para
     * eso hay que llamar a `supabase.auth.signOut()`, que además dispara el
     * evento SIGNED_OUT y deja este estado en cero por su cuenta.
     *
     * Antes se llamaba `signOut`, un nombre que prometía cerrar la sesión sin
     * hacerlo: quien lo usara creyendo lo contrario dejaba la sesión viva.
     */
    clearSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    user: null,
    role: null,
    isLoading: true,
    setUser: (user) => set({ user }),
    setRole: (role) => set({ role }),
    setLoading: (isLoading) => set({ isLoading }),
    clearSession: () => set({ user: null, role: null }),
}));
